'use client';

import { useState, useEffect } from 'react';

export const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState<boolean>(true);

  useEffect(() => {
    const checkIfDesktop = () => {
      // lg: 1024px according to tailwind
      setIsDesktop(window.innerWidth >= 1024);
    };
    checkIfDesktop();

    window.addEventListener('resize', checkIfDesktop);

    return () => {
      window.removeEventListener('resize', checkIfDesktop);
    };
  }, []);

  return isDesktop;
};
